import MigrationPending from '@/components/ui/MigrationPending'

export default function ClubsDashboardIndex() {
  return <MigrationPending title="Clubs Dashboard" subtitle="Sam's Club dashboard — migration to new stack pending" />
}

ClubsDashboardIndex.layout = MigrationPending.layout
